import React from 'react';

const Contact = (props) => {
    document.title = props.title;
    return(
        <section className="pnc-contact-us">
            <div className="container">
                <div className="row">
                    <div className="offset-md-2 col-md-10">
                        <div className="contact_us">
                            <h3 aria-level="1">Contact Us</h3>
                            <p>Have questions or need assistance? </p>
                            <p>Our PNC Yorktown representatives can assist you.</p>
                            <p> Just give us a call at <span>1-888-762-1576.</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Contact;